module.exports = __webpack_public_path__ + "img/DD_logo_320x86.80b0c338.png";